import productsEdit from '@/views/products/edit'
import productsList from '@/views/products/list'

export default [
  {
    path: '/produtos',
    name: 'productsList',
    component: productsList,
    meta: {
      layout: 'sidebar',
      type: 'list',
      base: 'products',
      heading: 'menu.products',
      auth: true,
      roles: [
        {
          create:  ['super-admin'],
          edit: ['super-admin'],
          remove: ['super-admin']
        }
      ]
    }
  },
  {
    path: '/produtos/novo',
    name: 'productsCreate',
    component: productsEdit,
    meta: {
      layout: 'sidebar',
      base: 'products',
      heading: 'menu.products',
      auth: true,
      roles: ['super-admin']
    }
  },
  {
    path: '/produtos/:id/editar',
    name: 'productsUpdate',
    component: productsEdit,
    meta: {
      layout: 'sidebar',
      base: 'products',
      heading: 'menu.products',
      auth: true,
      roles: ['super-admin']
    }
  }
]
